"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Types_1 = require("../../../../../Types");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
var Util_1 = require("../../../../../Services/Util");
var Endpoints_1 = require("../../../../../Utils/Endpoints");
var Services_1 = require("../../../../../Services");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var ArvatoRenewCertEventContentState;
(function (ArvatoRenewCertEventContentState) {
    ArvatoRenewCertEventContentState[ArvatoRenewCertEventContentState["Initial"] = 0] = "Initial";
    ArvatoRenewCertEventContentState[ArvatoRenewCertEventContentState["Pending"] = 1] = "Pending";
    ArvatoRenewCertEventContentState[ArvatoRenewCertEventContentState["Success"] = 2] = "Success";
    ArvatoRenewCertEventContentState[ArvatoRenewCertEventContentState["Error"] = 3] = "Error";
})(ArvatoRenewCertEventContentState || (ArvatoRenewCertEventContentState = {}));
var ArvatoRenewCertEventContent = /** @class */ (function (_super) {
    __extends(ArvatoRenewCertEventContent, _super);
    function ArvatoRenewCertEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.renewCert = function () {
            _this.updateModal(ArvatoRenewCertEventContentState.Pending);
            var body = JSON.stringify(_this.props.locationName);
            Util_1.postJson(Endpoints_1.default.RenewCert, body, undefined, true, new Util_1.UserRequestHeaders(__assign(__assign({}, Services_1.Auth.getUser()), { Location: _this.props.applicationData.selectedLocation })), true)
                .then(function (response) {
                _this.props.updateCallback(_this.props.locationName, response);
                _this.updateModal(ArvatoRenewCertEventContentState.Success);
            })
                .catch(function (err) {
                _this.updateModal(ArvatoRenewCertEventContentState.Error);
                _this.setState({
                    error: React.createElement("div", null, err.split(/(?:[.]{1}[ ]{1})/gm).map(function (value, index, array) {
                        return React.createElement("div", null,
                            value,
                            index !== array.length - 1 && React.createElement("br", null));
                    }))
                });
            });
        };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
            var event = eventHandler.GetEvent();
            switch (newState) {
                case ArvatoRenewCertEventContentState.Initial:
                    event.title = _this.props.applicationData.resources.ConfirmCertRenewal_Title;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Yes, "primary", function () {
                            _this.renewCert();
                        }), new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.No, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case ArvatoRenewCertEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.LoadingDotDotDot;
                    event.actions = [];
                    break;
                case ArvatoRenewCertEventContentState.Success:
                    event.title = _this.props.applicationData.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case ArvatoRenewCertEventContentState.Error:
                    event.title = _this.props.applicationData.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
            }
            eventHandler.UpdateEvent();
        };
        _this.state = {
            status: ArvatoRenewCertEventContentState.Initial,
            error: ""
        };
        return _this;
    }
    ArvatoRenewCertEventContent.prototype.render = function () {
        switch (this.state.status) {
            case ArvatoRenewCertEventContentState.Initial:
                return this.props.applicationData.resources.ConfirmCertRenewal_InitialMessage;
            case ArvatoRenewCertEventContentState.Pending:
                return (React.createElement(Components_1.CustomSpinner, null));
            case ArvatoRenewCertEventContentState.Success:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" }, this.props.applicationData.resources.ConfirmCertRenewal_SuccessMessage),
                        React.createElement(reactstrap_1.Col, null))));
            case ArvatoRenewCertEventContentState.Error:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-danger mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faTimesCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" }, this.state.error),
                        React.createElement(reactstrap_1.Col, null))));
        }
    };
    return ArvatoRenewCertEventContent;
}(React.Component));
exports.ArvatoRenewCertEventContent = ArvatoRenewCertEventContent;
//# sourceMappingURL=ArvatoRenewCertEventContent.js.map